import { IS_WEB } from 'constants/platform'
import React from 'react'

import { Box } from 'widgets/Box'
import { Image } from 'widgets/Image'
import { Text } from 'widgets/Text'

import { useUser } from 'hooks/useUser'

import { defaultPostThumbnailUrl } from 'utils/media'
import commonStyles from 'utils/styles/commonStyles'

type CreatorInfoProps = {
  creatorId?: string
}

export const CreatorInfo = ({ creatorId }: CreatorInfoProps) => {
  const { data: creator } = useUser({ userId: creatorId })

  const creatorAvatar = (IS_WEB ? creator?.avatar?.url : creator?.avatar) ?? defaultPostThumbnailUrl

  return (
    <Box flexDirection='row' align='center' margin={{ vertical: 'sm' }}>
      <Box
        width={44}
        height={44}
        borderRadius='xl'
        backgroundColor='v2lightGrey'
        style={commonStyles.overflowHidden}
      >
        <Image style={commonStyles.fullSize} resizeMode='cover' source={creatorAvatar} />
      </Box>

      <Box flex={1} margin={{ left: 'sm' }}>
        <Text fontSize='sm' bold numberOfLines={2} color='greyDarkest'>{`${
          creator?.firstName ?? ''
        } ${creator?.lastName ?? ''}`}</Text>
        <Text fontSize='sm' color='greyDarkest'>
          Creator
        </Text>
      </Box>
    </Box>
  )
}
